import { BadgeCheck, Scale } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { useLanguage } from "@/i18n/LanguageContext";
import { PANEL } from "./data";

export const Panel = () => {
  const { t } = useLanguage();
  return (
    <section id="panel" data-testid="panel-section" className="bg-navy-deep py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <Reveal><Overline className="justify-center">{t.panel.overline}</Overline></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-serif text-3xl font-medium leading-tight text-slate-50 sm:text-4xl lg:text-5xl">
              {t.panel.titleA} <span className="italic text-gold-gradient">{t.panel.titleB}</span>
            </h2>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-6 leading-relaxed text-slate-400">{t.panel.body}</p>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-8 md:grid-cols-3">
          {PANEL.map((m, i) => {
            const meta = t.panel.members[i];
            return (
              <Reveal key={m.name} delay={i * 0.1}>
                <article data-testid={`panel-member-${i}`}
                  className="group relative border border-navy-border bg-navy-card/60 p-3 transition-colors duration-500 hover:border-gold/50">
                  <div className="relative overflow-hidden">
                    <img src={m.image} alt={`Portrait of ${m.name}`} loading="lazy"
                      className="aspect-[4/5] w-full object-cover grayscale-[35%] transition-all duration-700 group-hover:scale-[1.03] group-hover:grayscale-0" />
                    <div className="absolute inset-0 bg-gradient-to-t from-navy-deep/95 via-navy-deep/10 to-transparent" />
                    <div className="absolute left-4 top-4 flex items-center gap-1.5 border border-gold/40 bg-navy-deep/80 px-2.5 py-1 backdrop-blur-sm">
                      <BadgeCheck className="h-3.5 w-3.5 text-gold" />
                      <span className="font-mono text-[9px] uppercase tracking-[0.2em] text-gold">{t.panel.verified}</span>
                    </div>
                    <div className="absolute inset-x-4 bottom-4">
                      <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-gold/90">{m.cases} {t.panel.awards}</div>
                      <h3 className="mt-1 font-serif text-2xl font-medium text-slate-50">{m.name}</h3>
                      <p className="text-sm text-gold-pale/90">{meta.role}</p>
                    </div>
                  </div>
                  <div className="space-y-3 px-3 py-5">
                    <div className="flex items-start gap-2.5">
                      <Scale className="mt-0.5 h-4 w-4 shrink-0 text-gold/70" strokeWidth={1.5} />
                      <p className="text-sm leading-snug text-slate-300">{meta.spec}</p>
                    </div>
                    <div className="h-px bg-navy-border" />
                    <p className="font-mono text-[10px] uppercase leading-relaxed tracking-[0.15em] text-slate-500">
                      {meta.jur}
                    </p>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
